export const metricDescriptions = {
  contract: 'Persentase pekerja yang memiliki nomor atau foto kontrak kerja. Pekerja dengan salah satunya mendapat nilai 100; jika tidak ada, nilainya 0.',
  insurance: 'Persentase pekerja yang memiliki status asuransi, atau memiliki nomor jaminan kesehatan dan jaminan ketenagakerjaan. Jika terpenuhi nilainya 100; jika tidak, nilainya 0.',
  minimumAge: 'Persentase pekerja yang sudah cukup umur saat mulai bekerja. Batas usia biasanya 18 tahun. Jika tanggal mulai bekerja tidak tersedia, usia saat ini yang digunakan.',
  onboardingScore: 'Nilai rata-rata dari kontrak kerja, perlindungan asuransi, dan usia minimum.',
  workHours: 'Perbandingan jam kerja dalam sebulan dengan standar jam bulanan. Hasilnya bisa lebih dari 100% jika jam kerja melebihi standar.',
  wageAboveMinimum: 'Perbandingan upah pekerja dengan upah minimum yang berlaku, dengan memperhitungkan jam kerjanya.',
  paymentLogs: 'Persentase pekerja yang memiliki catatan pembayaran upah. Jika catatan tersedia nilainya 100; jika tidak, nilainya 0.',
  productivity: 'Perbandingan waktu yang seharusnya dibutuhkan untuk menghasilkan barang dengan waktu kerja yang tercatat. Hasil produksi dan waktu kerja mengikuti data yang tersedia.',
  wageScore: 'Nilai rata-rata dari jam kerja, upah minimum, catatan pembayaran upah, dan produktivitas.',
}

// The report exposes its effective monthly standard on each member, including
// any adjustment made for the current month.
const getMembers = (entity) => {
  if (!entity) return []
  if (entity.detailData) return [entity]
  return entity.members
    || entity.suppliers?.flatMap((supplier) => supplier.members || [])
    || entity.regions?.flatMap((region) => region.suppliers?.flatMap((supplier) => supplier.members || []) || [])
    || []
}

// Backend sends detailData.workVariant (label of the ug_<variant> metadata key).
// ug_findoraworkresults => { id: 'Hasil Kerja', en: 'Work Results' }.
// ug_fwr_att ('Attendance + Work Results') is a different variant and is not matched.
const isWorkResultsMember = (member) => member?.detailData?.workVariant?.en === 'Work Results'

// True when every member of the entity uses the ug_findoraworkresults variant,
// so Work Hours and Productivity are indication only for the whole entity.
export const isIndicationOnlyGroup = (entity) => {
  const members = getMembers(entity)
  return members.length > 0 && members.every(isWorkResultsMember)
}

// True when at least one member uses ug_findoraworkresults (used for the legend note).
export const hasIndicationOnlyGroup = (entity) => getMembers(entity).some(isWorkResultsMember)

export const indicationOnlyDescriptions = {
  workHours: 'Parameter ini hanya sebagai indikasi dan tidak digunakan dalam perhitungan sebenarnya untuk grup ini.',
  productivity: 'Parameter ini hanya sebagai indikasi, tidak ada jam kerja aktual yang dicatat, dan digunakan sebagai acuan (benchmark).',
}

export const getStandardHours = (entity) => {
  const members = getMembers(entity)
  const values = [...new Set(members
    .map((member) => Number(member.detailData?.std_hours))
    .filter((hours) => Number.isFinite(hours) && hours > 0))]
  return values.length === 1 ? values[0] : null
}

export const getHoursDescriptions = (standardHours, indicationOnly = false) => {
  const base = standardHours == null
    ? metricDescriptions
    : (() => {
      const hours = new Intl.NumberFormat('id-ID', { maximumFractionDigits: 2 }).format(standardHours)
      return {
        ...metricDescriptions,
        workHours: `Perbandingan jam kerja dalam sebulan dengan standar ${hours} jam. Hasilnya bisa lebih dari 100% jika jam kerja melebihi standar.`,
        wageAboveMinimum: `Perbandingan upah pekerja dengan upah minimum yang berlaku, dengan memperhitungkan jam kerjanya. Standar jam kerja pada periode ini ${hours} jam.`,
      }
    })()
  return indicationOnly ? { ...base, ...indicationOnlyDescriptions } : base
}
